import React, { useEffect, useMemo, useState } from "react";
import { Question } from "./Question";
import styles from "./styles.module.css";

const ChatBotPosition = {
  RIGHT_PANEL_TOP: "right_panel_top",
  RIGHT_PANEL_MIDDLE: "right_panel_middle",
  RIGHT_PANEL_BOTTOM: "right_panel_bottom",
  EMBEDED: "embeded",
};

export const PreselectedQuestions = ({
  isFaqsOpen,
  onSelectQuestion,
  handleCloseFaqs,
  questions,
  position,
  title,
  description,
}) => {
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filteredQuestions, setFilteredQuestions] = useState(questions);

  useEffect(() => {
    if (questions) {
      const ary = [];
      questions.map((question) => {
        if (
          question?.questionCategory?.categoryName &&
          ary.filter(
            (cat) => cat.label === question?.questionCategory?.categoryName
          ).length === 0
        ) {
          ary.push({
            label: question?.questionCategory?.categoryName,
            value: question?.questionCategory?.categoryName,
          });
        }
      });
      setCategories(ary);
      setFilteredQuestions(questions);
      setSelectedCategory("");
    }
  }, [questions]);

  const handleSelectQuestion = (question) => {
    setSelectedQuestion(question);
    if (!question) return;

    onSelectQuestion && onSelectQuestion(question);
    setSelectedQuestion(null);
    handleCloseFaqs && handleCloseFaqs();
  };

  useEffect(() => {
    if (selectedCategory === "" || selectedCategory === null) {
      setFilteredQuestions(questions);
    } else {
      setFilteredQuestions(
        questions?.filter(
          (question) =>
            question?.questionCategory?.categoryName === selectedCategory
        )
      );
    }
  }, [selectedCategory]);

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const positionClassName = useMemo(() => {
    switch (position) {
      case ChatBotPosition.EMBEDED:
        return ` ${styles.preselectedQuestionsPositionBottom}`;
      case ChatBotPosition.RIGHT_PANEL_TOP:
        return ` ${styles.preselectedQuestionsPositionTop}`;
      case ChatBotPosition.RIGHT_PANEL_MIDDLE:
        return ` ${styles.preselectedQuestionsPositionMiddle}`;
      case ChatBotPosition.RIGHT_PANEL_BOTTOM:
        return ` ${styles.preselectedQuestionsPositionBottom}`;
      default:
        return ` ${styles.preselectedQuestionsPositionBottom}`;
    }
  }, [position]);

  return (
    <div
      className={`${styles.preselectedQuestionsContainer}${positionClassName}${
        isFaqsOpen ? ` ${styles.preselectedQuestionsContainerOpen}` : ""
      }`}
    >
      <button className={styles.closeButton} onClick={handleCloseFaqs}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L15 15M15 1L1 15"
            stroke="var(--chat-bot-darker-gray-color)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <h4 className="chatBotFont">{title}</h4>
      <p className="chatBotFont" style={{ marginTop: "6px" }}>
        {description}
      </p>

      <div>
        <select
          id="categories"
          onChange={handleCategoryChange}
          value={selectedCategory}
          className={styles.selectContainer}
        >
          <option value="">Select a category</option>
          {categories.map((category) => (
            <option key={category.value} value={category.value}>
              {category.label}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.questionListBox}>
        {!!filteredQuestions?.length &&
          filteredQuestions?.map((question) => (
            <Question
              key={question.id}
              isSelected={question.id === selectedQuestion?.id}
              text={question.question}
              onClick={() => handleSelectQuestion(question)}
            />
          ))}
      </div>
    </div>
  );
};
